import * as React from 'react'
import { Link } from 'react-router-dom'
import { Button, Callout, Intent, NonIdealState } from '@blueprintjs/core'
import { IconNames } from '@blueprintjs/icons'
import { UprightStyle } from '../../types'
import Widget from '../../components/Widget'
import { usePermissions } from '../../hooks/usePermissions'

const styles: UprightStyle = {
  linkAccountButtonContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  linkAccountButton: {
    width: 300,
    margin: '25px 0 10px'
  }
}

export const LinkAmazonAccountWarning: React.FC = () => {
  const { includesAllPermissions } = usePermissions()
  const canViewChannelSettings = includesAllPermissions('settings.channels')

  let accountLinkLabel = 'Ask your manager to link an Amazon account'
  if (canViewChannelSettings) {
    accountLinkLabel = 'Link your amazon account in admin settings'
  }

  return (
    <Widget>
      <Callout icon={IconNames.LIGHTBULB} intent="warning" title="New to scanning?" style={styles.newToAmazon}>
        You need to connect an Amazon account before continuing.{' '}
      </Callout>
      <NonIdealState
        icon={IconNames.FORM}
        title="No Amazon accounts linked yet"
        description={<p>{accountLinkLabel}</p>}
      />
      {canViewChannelSettings === true && (
        <div style={styles.linkAccountButtonContainer}>
          <Link to="/admin/amazon">
            <Button large intent={Intent.NONE} icon={IconNames.COG} style={styles.linkAccountButton}>
              Admin Settings
            </Button>
          </Link>
        </div>
      )}
    </Widget>
  )
}
